import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import { lazyLoad } from './lazyload-init.js';
var owlinit = 0;
var owlChanged;

$(function() {

    var bigimg = $("#development-gallery-slider");
    var smlimg = $("#development-gallery-slider-thumbs");
    var $galleryContainer = $('#development-gallery, #dev-landing-gallery-container');
    let lazyLoadInstance  = lazyLoad(); // Add lazyLoad
    var slidesPerPage = 4;
    var syncedSecondary = true;

    // Gallery section
    if( $galleryContainer.length ) {

        // owl Carousel Gallery Init
        function owlGalleryInit() {
            if( owlinit == 0 ) {
                owlinit = 1;

                bigimg
                .on('initialized.owl.carousel', function() {
                    // Add Video SRC
                    bigimg.find('.owl-item .video-wrapper iframe').each(function(){
                        var video_src = $(this).data('src');
                        $(this).attr('src', video_src);
                    });
                })
                .owlCarousel({
                        items: 1,
                        navSpeed: 800,
                        slideSpeed: 2000,
                        nav: true,
                        autoplay: false, 
                        dots: false,
                        loop: true,
                        responsiveRefreshRate: 200,
                        navText: [
                            '<i style="font-size: 50px" class="fas fa-chevron-left"></i>',
                            '<i style="font-size: 50px" class="fas fa-chevron-right"></i>'
                            ],
                    })
                    .on('changed.owl.carousel', function(el){

                        clearTimeout(owlChanged);
                        owlChanged = setTimeout(function(){

                            setTimeout(() => {
                                bigimg.find('.owl-item .video-wrapper iframe.current').each(function(){
                                    var video_src = $(this).data('src');
                                    $(this).removeAttr('src').removeClass('current').attr('src', video_src);
                                });
        
                                var $slideActive = bigimg.find(".owl-item.active");
                                if ( $slideActive.find('.video-wrapper').length ) {
                                    $slideActive.find('.video-wrapper iframe').addClass('current');
                                }
                            }, 0);
                        }, 200);

                        var count = el.item.count - 1;
                        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

                        if (current < 0) {
                            current = count;
                        }
                        if (current > count) {
                            current = 0;
                        }

                        smlimg
                            .find(".owl-item")
                            .removeClass("current")
                            .eq(current)
                            .addClass("current");
                        var onscreen = smlimg.find('.owl-item.active').length - 1;
                        var start = smlimg.find('.owl-item.active').first().index();
                        var end = smlimg.find('.owl-item.active').last().index();

                        if (current > end) {
                            smlimg.data('owl.carousel').to(current, 100, true);
                        }
                        if (current < start) {
                            smlimg.data('owl.carousel').to(current - onscreen, 100, true);
                        }
                        
                    });

                smlimg
                    .on('initialized.owl.carousel', function() {
                        smlimg.find(".owl-item").eq(0).addClass("current");
                        $("#galleryLoader").hide();
                    })
                    .owlCarousel({
                        items: slidesPerPage,
                        dots: true,
                        nav: false,
                        smartSpeed: 200,
                        slideSpeed: 500,
                        slideBy: slidesPerPage, 
                        responsiveRefreshRate: 100
                    })
                    .on('changed.owl.carousel', rackIndexSmall);
            }
            
        }          

        function rackIndexSmall(el) {
            if (syncedSecondary) {
                var number = el.item.index;
                //bigimg.data('owl.carousel').to(number, 800, true);
            }
        }

        smlimg.on("click", ".owl-item", function(e) {
            e.preventDefault();
            var number = $(this).index();
            bigimg.data('owl.carousel').to(number, 300, true);
        });

        /* Gallery Modal */
        $('#developmentGallery').on('show.bs.modal', function (e) {
            owlGalleryInit();
            var galleryItem = e.relatedTarget.dataset.itemId;
            //lazyLoadInstance.update(); // Update LazyLoad
            bigimg.trigger('to.owl.carousel', [galleryItem, 0]); 
        })
        $('#developmentGallery').on('hidden.bs.modal', function (e) {
            bigimg.find('.owl-item .video-wrapper iframe.current').each(function(){
                var video_src = $(this).data('src');
                $(this).removeAttr('src');
            });
        })
    }
});